export const ChangeCategoryModal: string = 'ChangeCategoryModal';
